/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular
  .module('app.services')
  .factory('practicesService', ['$http', '$log', function($http, $log) {

    let instance = {
      isSelected: (practice) => {
        return practice.isSelected;
      },
      selectAreas: (law_areas, selection) => {
        _.each(law_areas, area => {
          area.isSelected = selection;
          selectPractices(area.practices, selection);
        });

        function selectPractices(practices, selection) {
          _.each(practices, practice => {
            practice.isSelected = selection;
            selectSubAreas(practice.sub_areas, selection);
          });

        function selectSubAreas(subAreas, selection) {
            _.each(subAreas, subArea => {
                subArea.isSelected = selection;
              });
          }
        }
      },
      createHeirarchy: (linearPractices) => {
        let heirarchicalPractices = [];

        _.each(linearPractices, (area) => {
          if (area.law_area === null && area.practice_area === null) {
            area.practices = [];
            heirarchicalPractices.push(area);

            _.each(linearPractices, (prac_area) => {
              if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
                prac_area.sub_areas = [];
                area.practices.push(prac_area);

                _.each(linearPractices, (sub_area) => {
                  if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
                    prac_area.sub_areas.push(sub_area);
                  }
                });

              }
            });

          }
        });

        return heirarchicalPractices;
      },
      linearize: (heirarchicalPractices) => {
        let linearPractices = [];

        heirarchicalPractices.forEach(function(prac, index, array) {
          if (instance.isSelected(prac)){ linearPractices.push(prac); }

          prac.practices.forEach(function(law, index, array) {
            if (instance.isSelected(law)){ linearPractices.push(law); }

            law.sub_areas.forEach(function(sub, index, array) {
              if (instance.isSelected(sub)){ linearPractices.push(sub); }

            });
          });
        });

        return linearPractices;
      },
      clearSelection: function(heirarchicalPractices, selection = false) {
        instance.selectAreas(heirarchicalPractices, selection);
      },
      map: (linearPractices, heirarchicalPractices)=>{
          instance.clearSelection(heirarchicalPractices);
          linearPractices.forEach((tPrac, index, array) => {
            heirarchicalPractices.forEach( (area) => {
              if(tPrac.practice_ID === area.practice_ID){ area.isSelected = true; }

              area.practices.forEach((practice) => {
                if(tPrac.practice_ID === practice.practice_ID){
                  area.isSelected = true;
                  practice.isSelected = true;
                }
                practice.sub_areas.forEach( (sub_area) => {
                  if(tPrac.practice_ID === sub_area.practice_ID){
                    area.isSelected = true;
                    practice.isSelected = true;
                    sub_area.isSelected = true;
                  }
                });
              });
            });
          });
      },
      deselectSelection: function(heirarchicalPractices, selection = false) {
        instance.selectAreas(heirarchicalPractices, selection);
        $log.info("heirarchicalPractices",heirarchicalPractices);
      },
      checkForLinking: (allPracticeAreas, currentPracticeId, checkboxValue) => {
        const practiceIds = {
          corporate: 3,
          property: 76,
          projectFinance: 24,
          equityCapMarketForCapMarket: 22,
          equityCapMarketForCorporate: 61,
          bankingFinance: 1,
          capMarket: 19,
          constructionForProject: 25,
          constructionForProperty: 84,
        };

        let parent;
        let child;

        if (_.contains(practiceIds, currentPracticeId)) {

          switch (currentPracticeId) {
            case practiceIds.equityCapMarketForCapMarket:
              parent = practiceIds.corporate;
              child = practiceIds.equityCapMarketForCorporate;
              break;

            case practiceIds.equityCapMarketForCorporate:
              parent = practiceIds.capMarket;
              child = practiceIds.equityCapMarketForCapMarket;
              break;

            case practiceIds.capMarket:
              parent = practiceIds.corporate;
              child = practiceIds.equityCapMarketForCorporate;
              break;

            case practiceIds.corporate:
              parent = practiceIds.capMarket;
              child = practiceIds.equityCapMarketForCapMarket;
              break;

            case practiceIds.bankingFinance:
            case practiceIds.projectFinance:
            case practiceIds.constructionForProject:
              parent = practiceIds.property;
              child = practiceIds.constructionForProperty;
              break;

            case practiceIds.property:
            case practiceIds.constructionForProperty:
              parent = practiceIds.bankingFinance;
              child = practiceIds.constructionForProject;
              break;

            default:
              break;
          }

          let keepParentSelected;
          let keepChildParentSelected;
          return allPracticeAreas.forEach(function(lawArea, index, array) {
            if (lawArea.practice_ID === parent) {
              keepParentSelected = false;
              lawArea.practices.forEach(function(PracticeArea, index, array) {
                if (PracticeArea.practice_ID === child) {
                  PracticeArea.isSelected = checkboxValue;
                }

                if ( !PracticeArea.hasChild && PracticeArea.isSelected) {
                  keepParentSelected = true;
                } else {
                  keepChildParentSelected = false;
                  PracticeArea.sub_areas.forEach(function(area, index, array) {
                    if (area.practice_ID === child) {
                      area.isSelected = checkboxValue;
                    }
                    if (area.isSelected) {
                      keepParentSelected = true;
                      keepChildParentSelected = true;
                    }
                  });
                  PracticeArea.isSelected = keepChildParentSelected;
                }
              });

              lawArea.isSelected = keepParentSelected;
            }
          });
        }
      },
      select: (heirarchicalPractices, event, current, level) => {
        let pCounter, sCounter, value;
        pCounter = 0;
        sCounter = 0;
        value = event.target.checked;
        if (level === 2) {
          heirarchicalPractices.forEach(function(law_area, index, array) {
            if (law_area.practice_ID === current.practice_ID) {
              law_area.isSelected = value;
               law_area.practices.forEach(function(practice, index, array) {
                practice.isSelected = value;
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.isSelected !== value) {
                    sub.isSelected = value;
                  }
                });
              });
            }
          });
        } else if (level === 1) {
          heirarchicalPractices.forEach(function(law_area, index, array) {
             law_area.practices.forEach(function(practice, index, array) {
              if (practice.practice_ID === current.practice_ID) {
                practice.isSelected = value;
                law_area.practices.forEach(function(p, i, a) {
                  if (p.isSelected) {
                    pCounter++;
                  }
                });
                if (value) {
                  if (pCounter > 0) {
                    law_area.isSelected = value;
                  }
                } else {
                  if (pCounter <= 0) {
                    law_area.isSelected = value;
                  }
                }
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.isSelected !== value) {
                    sub.isSelected = value;
                  }
                });
              }
            });
          });
        } else if (level === 0) {
           heirarchicalPractices.forEach(function(law_area, index, array) {
            law_area.practices.forEach(function(practice, index, array) {
              if (practice.sub_areas.length > 0) {
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.practice_ID === current.practice_ID) {
                    sub.isSelected = value;
                    practice.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++;
                      }
                    });
                    if (value) {
                      if (sCounter > 0) {
                        law_area.isSelected = value;
                        practice.isSelected = value;
                      }
                    } else {
                      if (sCounter <= 0) {
                        practice.isSelected = value;
                        law_area.practices.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++;
                          }
                        });
                        if (value) {
                          if (pCounter > 0) {
                            law_area.isSelected = value;
                          }
                        } else {
                          if (pCounter <= 0) {
                            law_area.isSelected = value;
                          }
                        }
                      }
                    }
                  }
                });
              }
            });
          });
        }
      }

    };

    return instance;
  }]);



// WEBPACK FOOTER //
// ./scripts/shared/services/practices.js